// Shared current-user/role/permission helpers (single source for access checks).
import API from './api';

export function getUser() {
  try { return JSON.parse(localStorage.getItem('user')) || null; }
  catch (_) { return null; }
}
export function getRole() {
  return getUser()?.role || null;
}
export function isLimitedAdmin() {
  return getRole() === 'LIMITED_ADMIN';
}
export function isFullAdmin() {
  const r = getRole();
  return r === 'OFFICE_ADMIN' || r === 'PORTAL_ADMIN';
}
export function isAnyAdmin() {
  return isFullAdmin() || isLimitedAdmin();
}

// Granted areas for the current user (from the last /permissions/me fetch).
export function getPermissions() {
  try { return JSON.parse(localStorage.getItem('permissions')) || []; }
  catch (_) { return []; }
}

// True if the current user may use a given area. Full admins always can.
export function hasArea(area) {
  if (isFullAdmin()) return true;
  return getPermissions().includes(area);
}

// Refresh the current user's effective permissions from the server. Admin-only;
// no-op (returns cached) for therapists or when unauthenticated.
export async function refreshPermissions() {
  if (!isAnyAdmin()) return getPermissions();
  try {
    const res = await API.get('/admin/permissions/me');
    const perms = Array.isArray(res.data?.permissions) ? res.data.permissions : [];
    localStorage.setItem('permissions', JSON.stringify(perms));
    return perms;
  } catch (_) {
    return getPermissions();
  }
}

export function clearPermissions() {
  localStorage.removeItem('permissions');
}
